/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface VendorWorkspaceInviteLogControlllerCancelInvite$Params {

/**
 * 초대 ID
 */
  inviteId: string;

/**
 * 입점사 ID
 */
  vendorWorkspaceId: string;
}

export function vendorWorkspaceInviteLogControlllerCancelInvite(http: HttpClient, rootUrl: string, params: VendorWorkspaceInviteLogControlllerCancelInvite$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceInviteLogControlllerCancelInvite.PATH, 'post');
  if (params) {
    rb.path('inviteId', params.inviteId, {});
    rb.path('vendorWorkspaceId', params.vendorWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

vendorWorkspaceInviteLogControlllerCancelInvite.PATH = '/api/vendorWorkspaceInviteLogs/{vendorWorkspaceId}/invite/{inviteId}/cancel';
